function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { TextFieldComponent } from "../../../Inputs/Input";
var useStyles = makeStyles({
  inputBaseCustom: {
    display: 'flex !important',
    padding: '14.5px  14px',
    height: '27px'
  }
});
export function InputComponentReactMobile(_ref) {
  var inputRef = _ref.inputRef,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["inputRef", "className"]);

  var classes = useStyles();
  var newClass = clsx(classes.inputBaseCustom, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: inputRef,
    className: newClass
  }, props));
}
export function InputComponentReact(_ref2) {
  var inputRef = _ref2.inputRef,
      props = _objectWithoutProperties(_ref2, ["inputRef"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: inputRef
  }, props));
}
export var Controlnput = function Controlnput(_ref3) {
  var _clsx;

  var selectProps = _ref3.selectProps,
      innerProps = _ref3.innerProps,
      innerRef = _ref3.innerRef,
      children = _ref3.children;
  return /*#__PURE__*/React.createElement(TextFieldComponent, _extends({
    fullWidth: true,
    InputProps: {
      inputComponent: selectProps.variant === 'mobile' && selectProps.isMulti ? InputComponentReactMobile : InputComponentReact,
      inputProps: _objectSpread({
        className: clsx(selectProps.childrenClasses.input, (_clsx = {}, _defineProperty(_clsx, selectProps.childrenClasses.inputMultilineDense, selectProps.variant === 'web' && selectProps.isMulti && selectProps.value.length > 0), _defineProperty(_clsx, selectProps.childrenClasses.inputNormal, selectProps.variant === 'web' && (!selectProps.isMulti || selectProps.isMulti && selectProps.value.length === 0)), _clsx)),
        inputRef: innerRef,
        children: children
      }, innerProps)
    }
  }, selectProps.textFieldProps, {
    classes: selectProps.childrenClasses
  }));
};